export default function StorePickup() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4 text-gray-900">
          店舗受取可能なクレジットカード
        </h2>
        <p className="text-center text-gray-600 mb-12">
          一部のカードは店舗で即日受取が可能です
        </p>

        <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-8 mb-8">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-store-2-line text-white text-2xl"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                店舗受取のメリット
              </h3>
              <p className="text-gray-700 leading-relaxed">
                店舗で直接カードを受け取れるため、郵送を待つ必要がありません。申込み当日から利用開始できるのが最大のメリットです。
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-teal-600 text-xl"></i>
                </div>
                <h4 className="font-bold text-gray-900">即日利用可能</h4>
              </div>
              <p className="text-sm text-gray-700">
                審査通過後、その日のうちにカードを受け取って利用開始できます
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-teal-600 text-xl"></i>
                </div>
                <h4 className="font-bold text-gray-900">安心・安全</h4>
              </div>
              <p className="text-sm text-gray-700">
                郵送中の紛失リスクがなく、直接受け取れるので安心です
              </p>
            </div>
          </div>
        </div>

        <div className="bg-amber-50 border-l-4 border-amber-400 rounded-lg p-6">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-amber-600 text-2xl flex-shrink-0 mt-1"></i>
            <div>
              <h4 className="font-bold text-gray-900 mb-2">現在の店舗受取対応状況</h4>
              <p className="text-gray-700 mb-4">
                2026年現在、主要なクレジットカードの多くはオンライン申込み後、郵送での受取が主流となっています。
              </p>
              <p className="text-gray-700">
                <strong className="text-gray-900">三井住友カード（NL）</strong>は、カード番号を最短10秒でアプリに発行できるため、実質的に即日利用が可能です。プラスチックカードは後日郵送されますが、アプリでネットショッピングやスマホ決済がすぐに使えます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
